<div *ngIf="showSpinnerBackdrop" class="spinner-backdrop"></div>
<mat-spinner *ngIf="showSpinner" class="fxhp-loading-spinner"></mat-spinner>
